import React from 'react'
import styled from 'styled-components'
import { Col, Container, Row } from 'react-bootstrap'
import { Box, LazyImage, MainHeading, TextStyled, HeadingStyled, SpanStyled } from '../../../ui/Elements'
import { ArrowBtn, ArrowBtnBrown, HeroBg, HeroBgAr, Lights, Sofa, TransformBg } from '../../../ui/AllImages'
import { useTranslation } from 'react-i18next'
import { ContactButton } from '../../../ui/CustomElements'
import ServicesBlocks from './serviceContent/ServicesBlocks'
import { trackSnapWhatsAppClick, waMessage } from '../../../services/snapPixel'
const Services = () => {
    const { t } = useTranslation();
    const WhatsApp = () => {
        const phoneNumber = '+966560532519';
        const message = waMessage();
        const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
        trackSnapWhatsAppClick('services');
        window.open(whatsappURL, '_blank');
    };
    return (
        <>
            <ServicesWapper className='container-fluid common-space servicesFluid' id="services">
                <Container>
                    <Box className='servicesRow row'>
                        <Col md={12} className="servicesColMain">
                            <Row className='m-0'>
                                <Col md={12}>
                                    <Box className='servicesDescRow row'>
                                        <Box className='lights'>
                                            <LazyImage src={Lights} />
                                        </Box>
                                        

                                        <Col md={12} lg={6} className="servicesDescCol servicesDescCol1">
                                            <Box className='servicesDescCol1Content'>
                                                <MainHeading className='main-heading mb-1 servicesMH' size="48px" color="var(--themeColor)">
                                                    {t('CompleteSolution')}
                                                </MainHeading>
                                                <MainHeading className='main-heading mb-1 servicesIH' size="28px" color="var(--secondaryColor)">
                                                    {t('FromDesignFurniture')}
                                                </MainHeading>
                                            </Box>
                                            
                                        </Col>
                                        <Col md={12} lg={6} className="servicesDescCol servicesDescCol2">
                                            <Box className='servicesDescCol2Content'>
                                                <SpanStyled className='d-flex mb-4 transformTxt' color='var(--secondaryColor)' size="20px">
                                                    {t('weoffercompleteinterior')}
                                                </SpanStyled>
                                                <SpanStyled className='d-flex align-items-center gap-2'>
                                                    <ContactButton icon={ArrowBtn} label={t('ContactUs')} onClick={WhatsApp} />
                                                </SpanStyled>
                                            </Box>
                                            
                                        </Col>
                                    </Box>
                                </Col>
                            </Row>
                        </Col>
                        <Col md={12} className="servicesColBlocks">
                            <ServicesBlocks />
                        </Col>
                    </Box>
                </Container>
            </ServicesWapper>
        </>
    )
}
const ServicesWapper = styled.section`
    padding-bottom: 0;
    
    
    & > .container{
        .servicesRow{
            /* margin-left: 0;
            margin-right: 0; */
        }
        .lights{
            position: absolute;
            width: fit-content;
            top: -95px;
            left: 46%;
        }
        .servicesDescRow{
            position: relative;
        }
        .servicesDescCol1{
            display: flex;
            justify-content: center;
        }
        .servicesDescCol1Content{
            display: inline-block;
            max-width: 520px;
        }
        .servicesDescCol2{
            display: flex;
            justify-content: center;
            padding-left: 200px;
            .servicesDescCol2Content{
                display: inline-block;
                width: 320px;
            }
        }
        
        
    }
    body.rtl &{
        & > .container{
            .servicesMH{
                font-size: 48px;
            }
            .servicesIH{
                font-size: 28px
            }
            .servicesDescCol2 {
                padding-left: 0;
                padding-right: 200px;
            }
            .servicesDescCol1Content {
                max-width: 490px;
            }
            .lights {
                left: 36%;
            }
        }
    }
    
    @media (max-width: 1399px) {
        
    }
    @media (max-width: 1299px) {
        & > .container{
            
        }
        body.rtl &{
            & > .container{
                
                
            }
        }
    }
    @media (max-width: 1199px) {
        & > .container{
            
            
        }
        body.rtl &{
            & > .container{
                .lights {
                    left: 32%;
                }
                
            }
        }
    }
    @media (max-width: 991px) {
        & > .container{
            .servicesDescCol{
                padding: 0;
                
            }
            .servicesMH{
                font-size: 40px;
            }
            .servicesDescCol1Content {
                max-width: 100%;
            }
            .servicesDescCol1{
                justify-content: flex-start;
                margin-bottom: 10px;
            }
            .servicesDescCol2{
                .servicesDescCol2Content{
                    width: 100%;
                }
            } 
            .lights{
                display: none;
            }
            
        }
        body.rtl &{
            & > .container{
                .servicesDescCol1Content {
                    max-width: 100%;
                }
                .servicesDescCol2 {
                    padding-left: 0;
                    padding-right: 0;
                }
                .servicesMH{
                    font-size: 40px;
                }
                .servicesIH{
                    font-size: 24px;
                }
            }
        }
    }
    @media (max-width: 767px) {
        & > .container{
            .servicesMH{
                font-size: 35px;
            }
            .servicesIH{
                font-size: 24px;
            }
            .transformTxt{
                font-size: 18px;
            }
            
        }
        body.rtl &{
            & > .container{
                .servicesMH{
                    font-size: 35px;
                }
                .servicesIH{
                    font-size: 24px;
                }
                .transformTxt{
                    font-size: 18px;
                }
                
            }
        }
    }
    @media (max-width: 640px) {
       
    }
    @media (max-width: 575px) {
        
    }
    @media (max-width: 350px) {
        
    }
`
export default Services
